import React, { useState, useEffect } from 'react';
import ProductList from '../components/Boutique/ProductList';
import Cart from '../components/Boutique/Cart';
import PaymentModal from '../components/Boutique/PaymentModal';
import CategoryFilter from '../components/Boutique/CategoryFilters';
import productsData from '../components/Boutique/Products';
import '../styles/Boutique/LaBoutique.css';
import '../styles/Boutique/Disclaimer.css';
import cartimg from '../assets/boutique/cart.png';

const LaBoutique = () => {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [priceSort, setPriceSort] = useState('none');

  const categories = [
    'ACCESSOIRES VESTIMENTAIRES',
    'AUTOCOLLANTS CARTES POSTALES',
    'BANDESDESSINEES',
    'BIJOUX',
    'CD / DVD / CARNETS CHANTS',
    'COIFFURES',
    'COUTEAUX',
    'DIVERS',
    'INSIGNES ET PIN\'S',
    'LIVRES',
    'MAGNETS',
    'MONNAIE ET BILLET',
    'MUGS',
    'PARFUM',
    'POLOS - T-shirt',
    'PORTE-CLEFS',
    'STYLOS'
  ];

  useEffect(() => {
    const savedCart = sessionStorage.getItem('cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    const existingItem = cart.find(item => item.name === product.name && item.selectedSize === product.selectedSize);
    if (existingItem) {
      setCart(cart.map(item => item.name === product.name && item.selectedSize === product.selectedSize ? { ...item, quantity: item.quantity + 1 } : item));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const removeFromCart = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1);
    setCart(newCart);
  };

  const changeQuantity = (productName, change) => {
    setCart(cart.map(item => item.name === productName ? { ...item, quantity: Math.max(1, item.quantity + change) } : item));
  };

  const openCartModal = () => {
    setIsCartOpen(true);
  };

  const closeCartModal = () => {
    setIsCartOpen(false);
  };

  const openPaymentModal = () => {
    setIsCartOpen(false);
    setIsPaymentOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentOpen(false);
  };

  const handleCategorySelect = (e) => {
    if (e.target.value === '') {
      setSelectedCategories([]);
    } else {
      setSelectedCategories([e.target.value]);
    }
  };

  return (
    <div>
      <div className="disclaimer">
        <p>Pour toute commande comprenant plusieurs articles dont un casque ou un mug ou un parfum, prenez contact avec l'association <a href="FormulaireAssociation" target="_blank" style={{ color: 'var(--tdm-blue)', textDecoration: 'none' }}>ici</a></p>
      </div>
      <button className="cart-button" onClick={openCartModal}>
        <img src={cartimg} alt="Accéder au panier" />
        <span className="notification-bubble">{cart.reduce((total, item) => total + item.quantity, 0)}</span>
      </button>
      <div className="controls">
        <select id="priceSort" className="filter-button" onChange={(e) => setPriceSort(e.target.value)}>
          <option value="none">Trier par prix</option>
          <option value="asc">Prix croissant</option>
          <option value="desc">Prix décroissant</option>
        </select>
        <select id="categorySelect" className="filter-button" onChange={handleCategorySelect}>
          <option value="">Toutes les catégories</option>
          {categories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>
      <div className="main-content">
        <div className="category-column">
          <div className="category-card">
            <CategoryFilter selectedCategories={selectedCategories} setSelectedCategories={setSelectedCategories} />
          </div>
        </div>
        <ProductList products={productsData} selectedCategories={selectedCategories} priceSort={priceSort} addToCart={addToCart} />
      </div>
      <Cart isOpen={isCartOpen} closeCart={closeCartModal} cart={cart} removeFromCart={removeFromCart} changeQuantity={changeQuantity} openPaymentModal={openPaymentModal} />
      <PaymentModal isOpen={isPaymentOpen} closeModal={closePaymentModal} cart={cart} />
    </div>
  );
};

export default LaBoutique;
